import React, { useLayoutEffect, useState } from 'react'
import { CustomModal, Btn, InputDate, InputText } from '../../../../components'
import './ModalEditarPosicao.css'

export default function ModalEditarPosicao({ show, onClose, onSave, itemData }) {
  const [validade, setValidade] = useState('')
  const [lote, setLote] = useState('')
  const [inputKey, setInputKey] = useState(0)

  useLayoutEffect(() => {
    if (!show) {
      return
    }

    const nextValidade = itemData && itemData.validade ? itemData.validade : ''
    const nextLote = itemData && itemData.lote ? itemData.lote : ''

    setValidade(nextValidade)
    setLote(nextLote)
    setInputKey(prevKey => prevKey + 1)
  }, [show, itemData])

  const handleSave = () => {
    onSave({ validade, lote })
  }

  const handleClose = () => {
    setValidade('')
    setLote('')
    onClose()
  }

  return (
    <CustomModal isVisible={show} header="Editar Posição" onClose={handleClose}>
      <div className="modal-editar-posicao">
        <div className="p-grid">
          <div className="p-col-12">
            <InputDate
              key={inputKey}
              label="Validade"
              value={validade}
              onChange={value => setValidade(value)}
              marginTop={10}
            />
          </div>
          <div className="p-col-12">
            <InputText
              label="Lote"
              value={lote}
              onChange={value => setLote(value)}
              marginTop={10}
            />
          </div>
        </div>
        <div className="p-grid p-justify-start" style={{ marginTop: 20 }}>
          <div className="p-col-3">
            <Btn onClick={handleSave}>Salvar</Btn>
          </div>
        </div>
      </div>
    </CustomModal>
  )
}
